






































import {Component} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {CostTranshipmentStore} from "@/modules/receiptsexpenses/updatecosttranshipment/store";
import UpdateCostTranshipmentId
    from "@/modules/receiptsexpenses/updatecosttranshipment/components/UpdateCostTranshipmentId/index.vue";
import CostTranshipmentMonthPicker
    from "@/modules/receiptsexpenses/updatecosttranshipment/components/MonthPicker/index.vue";
import {CostTranshipmentParams} from "@/modules/receiptsexpenses/updatecosttranshipment/params";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";

@Component({
    name: "UpdateCostTranshipment",
    components: {CostTranshipmentMonthPicker, UpdateCostTranshipmentId, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    params: CostTranshipmentParams = new CostTranshipmentParams();
    data = {
        id: null
    }
    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 60
        },
        {
            title: "Ngày giờ chuyển",
            dataIndex: "pickingListTranshipment.createdDate",
            key: "createdDate",
            width: 150,
            ellipsis: true
        },
        {
            title: "Số hiệu bảng kê",
            dataIndex: "pickingListTranshipment.code",
            key: "code",
            width: 150,
            ellipsis: true
        },
        {
            title: "Đối tác vận chuyển",
            dataIndex: "pickingListTranshipment.partner.name",
            key: "name",
            width: 150,
            ellipsis: true
        },
        {
            title: "Khối lượng bảng kê",
            dataIndex: "pickingListTranshipment.weight",
            key: "weight",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: 'weight'}
        },
        {
            title: "Chứng từ vận chuyển",
            dataIndex: "transhipmentDocument",
            key: "transhipmentDocument",
            width: 150,
            ellipsis: true
        },
        {
            title: "Phí vận chuyển",
            dataIndex: "feeTranshipment",
            key: "feeTranshipment",
            width: 150,
            ellipsis: true,
            scopedSlots: { customRender: 'feeTranshipment' }
        },
        {
            title: "Phí cộng thêm",
            dataIndex: "feeAdd",
            key: "feeAdd",
            width: 150,
            ellipsis: true,
            scopedSlots: { customRender: 'feeAdd' }
        },
        {
            title: "Tổng phí",
            dataIndex: "total",
            key: "total",
            width: 150,
            ellipsis: true,
            scopedSlots: { customRender: 'total' }
        },
        {
            title: "Sửa",
            dataIndex: "id",
            key: "action",
            scopedSlots: {customRender: 'action'},
            width: 100
        },
    ];


    get costTranshipments() {
        return CostTranshipmentStore.costTranshipments;
    }

    created() {
        CostTranshipmentStore.updateParamsCostTranshipment(this.params)
    }

    get pagination() {
        return {
            current: CostTranshipmentStore.meta.page,
            pageSize: CostTranshipmentStore.meta.limit,
            total: CostTranshipmentStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        CostTranshipmentStore.listCostTranshipment({
            ...CostTranshipmentStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        });
    }

    onEdit(id) {
        this.$set(this.data, "id", id)
    }
}
